import { render, staticRenderFns } from "./PathAddEditView.vue?vue&type=template&id=4df97d32&scoped=true&"
import script from "./PathAddEditView.vue?vue&type=script&lang=js&"
export * from "./PathAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./PathAddEditView.vue?vue&type=style&index=0&id=4df97d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df97d32",
  null
  
)

export default component.exports